export default __webpack_public_path__ + "static/media/CalendarMeeting.2ece5ea9.svg";